export class ListSaasEntitySnapshotsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitySnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
